<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div  class="animated fadeIn">
    <template v-if="base">
      <List v-show="list" ref="list" />
    </template>
    <Detail v-if="detail" @refresh="refresh" />
  </div>
</template>

<script>
// import moment from 'moment-timezone';
// import { Api } from '@/f1/service';


import List from './Webshell.List';
import Detail from './Webshell.Detail';

export default {
  components: { List, Detail },
  data: () => ({ base: false, list: false, detail: false, mdetail: false }),
  methods: {
    refresh() {
      console.log("refresh", this.$refs.list.$children)
      if(this.$refs.list) {
        this.$refs.list.$children.forEach(ch => {
          ch.$children ? ch.$children.forEach(c => c.refresh != undefined && c.refresh()) : ch.refresh()
        })
      }
    },
    // refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }, name) {
      name = name == undefined ? "webshell" : name; //dashboard에서 rule create 위한 조건
      if(id && name) { this.list = false; this.mdetail = false; this.detail = true;}
      // else if(name == "webshell_mdit"){ this.list = false; this.detail = false; this.mdetail = true; }
      else { this.detail = false; this.mdetail = false; this.base = this.list = true;  }
      console.log('tag', tag)
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('[vue] cti webshell', 'route changed', to.param, from);
      this.select(to.params, to.name);
    }
  },
  created: function() { console.log('[vue] cti webshell', 'created'); },
  destroyed: function() { console.log('[vue] cti webshell', 'destroyed'); },
  mounted: function() {
    console.log('[vue] cti webshell', 'mounted');
    this.select(this.$route.params);
  },
}
</script>
